module.exports = __webpack_public_path__ + "img/SOKAL-SRS-120921-Tucson-Modern.e8e63bcb.jpeg";